<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="societe_categorie"
      v-model="sasSociete.categorieDeSociete"
      :live="liveSociete(25904)"
      :filter="(fd) => fd.code === 'spnp' || fd.code === 'spp'"
      @eudo-updated="categorieChanged"
    />
    <TextFieldLive code="societe_nom" v-model="sasSociete.nomDeLaSociete" :live="liveSociete(25905)" />
    <CatalogueLive code="societe_forme_juridique" v-model="sasSociete.formeJuridique" :live="liveSociete(25906)" />
    <TextFieldLive
      code="societe_neq"
      v-model="sasSociete.numeroDEntrepriseDuQuebec"
      :live="liveSociete(25908)"
      @eudo-updated="checkIfNeqExists"
      :disabled="neqLoading"
      :loading="neqLoading"
    />
    <v-alert type="error" text v-show="organisationFound">
      <Ressource code="neq_existant" />
    </v-alert>
    <v-checkbox class="list_counter_validator my-2 ml-6 p-0" :input-value="organisationFound" :rules="[(v) => !v || '']"> </v-checkbox>
    <DatePickerLive code="societe_date_debut" v-model="sasSociete.dateDebutActivite" :live="liveSociete(25909)" :minValue="serverDate()" />
    <TextFieldLive code="societe_adresse_ligne_1" v-model="sasSociete.adresseLigne1" :live="liveSociete(25910)" ref="adresse" id="adresse-field" />
    <TextFieldLive code="societe_adresse_ligne_2" v-model="sasSociete.adresseLigne2" :live="liveSociete(25911)" ref="completementDAdresse" />
    <TextFieldLive code="societe_ville" v-model="sasSociete.ville" :live="liveSociete(25912)" ref="ville" />
    <TextFieldLive code="societe_codepostal" v-model="sasSociete.codePostal" :live="liveSociete(25913)" ref="codePostal" />
    <CatalogueLive
      code="societe_province"
      v-model="sasSociete.province"
      :live="liveSociete(25907)"
      :filter="(fd) => fd.code === 'QC'"
      ref="province"
    />
    <CatalogueLive code="societe_pays" v-model="sasSociete.pays" :live="liveSociete(25914)" :filter="(fd) => fd.code === 'CA'" ref="pays" />
    <TextFieldLive code="societe_telephone" v-model="sasSociete.telephone" :live="liveSociete(25915)" />
    <TextFieldLive code="societe_telecopieur" v-model="sasSociete.telecopieur" :live="liveSociete(25916)" />
    <FileInput
      code="societe_certificat_constitution"
      :file="sasSociete.statutsConstitutifsDeLaSociete"
      :live="liveSociete(25917)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
      :opqIf="conditionStatutsConstitutifsDeLaSociete"
    />
    <FileInput
      code="societe_contrat"
      :file="sasSociete.contratDeLaSociete"
      :live="liveSociete(25918)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
      :opqIf="conditionContratDeLaSociete"
    />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import PosteCanada from "@/mixins/PosteCanada"
import { eventBus } from "@/plugins/eventBus"
import { organisationExistByNeq } from "@/plugins/services/organisations"
import Ressource from "@/components/ui/Ressource.vue"

export default {
  mixins: [CataloguesHelpers, DatesHelpers, StepFormWithValidation, PosteCanada],
  components: { Ressource },
  props: {
    sas: { type: Object }
  },
  mounted() {
    this.checkIfNeqExists()
  },
  data() {
    return {
      neqLoading: false,
      organisationFoundModal: false,
      organisationFound: false
    }
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionStatutsConstitutifsDeLaSociete() {
      return this.getCatalogueCodeById("328", this.sas.sasSociete.formeJuridique) === "SPA"
    },
    conditionContratDeLaSociete() {
      return this.getCatalogueCodeById("328", this.sas.sasSociete.formeJuridique) === "SENCRL"
    }
  },
  methods: {
    liveSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
    categorieChanged() {
      eventBus.$emit("categorieChanged")
    },

    checkIfNeqExists() {
      this.neqLoading = true
      organisationExistByNeq(this.sasSociete.numeroDEntrepriseDuQuebec)
        .then((res) => {
          this.organisationFoundModal = res.data.found
          this.organisationFound = res.data.found
        })
        .finally(() => {
          this.neqLoading = false
        })
    }
  }
}
</script>

<style></style>
